import React from "react";
import WhoIAm from "./WhoIAm";
import Techno from "./Techno";
import Footer from "./Footer";
import Navbar from "./Navbar";

const About = () => {
  return (
    <div>
    <Navbar />
    <WhoIAm />
    <Techno />
    <Footer />
    </div>
  );
}

export default About;
